exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.placeholder[data-v-e1cbaa30] {\n  height: -webkit-fit-content;\n  height: fit-content;\n}\n.box[data-v-e1cbaa30] {\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n  line-height: 1.5;\n}\n.box .large[data-v-e1cbaa30] {\n    font-size: 30px;\n    margin-bottom: 15px;\n    font-weight: 600;\n}\n.toggle[data-v-e1cbaa30] {\n  margin-top: 15px;\n  cursor: pointer;\n}\n.toggle[data-v-e1cbaa30]:hover {\n    font-weight: 600;\n}\n.account[data-v-e1cbaa30] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.account.total[data-v-e1cbaa30] {\n    font-weight: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-e1cbaa30","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/economy/components/costpricePerHour.vue
// module id = 591
// module chunks = 0